import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CoverImg } from "@/components/ui/CoverImg";
import { musicService } from "@/services/musicService";
import { usePlayer } from "@/hooks/usePlayer";
import type { Track } from "@/types/types";

export function SinglePage() {
  const { id = "" } = useParams();
  const [track, setTrack] = useState<Track | null>(null);
  const p = usePlayer();
  useEffect(() => { musicService.track(id).then(setTrack).catch(console.error); }, [id]);
  if (!track) return null;
  return (
    <div className="hero" style={{
      display: "flex", flexDirection: "row", alignItems: "flex-end",
      gap: 28, marginBottom: 28,
    }}>
      <CoverImg coverId={track.album?.cover_id} alt={track.title} size={232} />
      <div style={{ display: "flex", flexDirection: "column", gap: 10, paddingBottom: 6, minWidth: 0 }}>
        <div className="muted" style={{ fontSize: 13 }}>Single</div>
        <h1 style={{ margin: 0, fontSize: 52, lineHeight: 1.05, fontWeight: 800 }}>{track.title}</h1>
        <div className="muted" style={{ fontSize: 14, fontWeight: 600 }}>{track.artist.name}</div>
        <div>
          <button className="btn primary" style={{ marginTop: 10 }}
                  onClick={() => void p.playOne(track)}>▶ Lire</button>
        </div>
      </div>
    </div>
  );
}
